"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreRequest = void 0;
var error_1 = require("./error");
var RestoreRequest = /** @class */ (function () {
    function RestoreRequest(_a) {
        var wallet = _a.wallet, credentials = _a.credentials, emergency = _a.emergency, recoveryOTP = _a.recoveryOTP;
        this.wallet = wallet;
        this.credentials = credentials;
        this.emergency = emergency;
        this.recoveryOTP = recoveryOTP;
        if (!this.credentials.identity ||
            !this.credentials.password ||
            !this.credentials.verificationKey ||
            !this.credentials.boxedRemoteShare) {
            throw new error_1.ValidationError("Received a request to create a restore request. Rejecting it because all credentials parameters is required.");
        }
        if (!this.emergency.share1 ||
            !this.emergency.share2 ||
            !this.emergency.identity ||
            !this.emergency.password ||
            !this.emergency.boxedUsername) {
            throw new error_1.ValidationError("Received a request to create a restore request. Rejecting it because all emergency parameters is required.");
        }
        if (!this.recoveryOTP) {
            throw new error_1.ValidationError("Received a request to create a restore request. Rejecting it because the recovery OTP from the recover response is required.");
        }
    }
    return RestoreRequest;
}());
exports.RestoreRequest = RestoreRequest;
//# sourceMappingURL=restoreRequest.js.map